import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ObjectionHandler } from './components/ObjectionHandler';
import { TestimonialSection } from './components/TestimonialSection';
import { CTASection } from './components/CTASection';
import { BookCallSection } from './components/BookCallSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-orange-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <ObjectionHandler data-id="element-4" />
        <TestimonialSection data-id="element-5" />
        <BookCallSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}